var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RequestsTableRedesigned',{attrs:{"api-url-props":'/v2/requests?unassigned=true',"title":"Unassigned Requests"}})}
var staticRenderFns = []

export { render, staticRenderFns }